var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillingBankAccountGeneric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.4419,
    height: 48,
    rx: 12,
    fill: "#EFEDF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#A29DAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3125 22.0625C31.6232 22.0625 31.875 22.3143 31.875 22.625V28.4375C31.875 28.7481 31.6232 29 31.3125 29C31.0019 29 30.75 28.7481 30.75 28.4375V22.625C30.75 22.3143 31.0019 22.0625 31.3125 22.0625ZM34.3125 22.0625C34.6232 22.0625 34.875 22.3143 34.875 22.625V28.4375C34.875 28.7481 34.6232 29 34.3125 29C34.0018 29 33.75 28.7481 33.75 28.4375V22.625C33.75 22.3143 34.0018 22.0625 34.3125 22.0625ZM37.6875 22.0625C37.9982 22.0625 38.25 22.3143 38.25 22.625V28.4375C38.25 28.7481 37.9982 29 37.6875 29C37.3768 29 37.125 28.7481 37.125 28.4375V22.625C37.125 22.3143 37.3768 22.0625 37.6875 22.0625ZM40.6875 22.0625C40.9981 22.0625 41.25 22.3143 41.25 22.625V28.4375C41.25 28.7481 40.9981 29 40.6875 29C40.3768 29 40.125 28.7481 40.125 28.4375V22.625C40.125 22.3143 40.3768 22.0625 40.6875 22.0625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6245 17.1437C35.8382 16.9521 36.1618 16.9521 36.3755 17.1437L41.813 22.0187C41.9865 22.1743 42.0461 22.4208 41.9628 22.6385C41.8795 22.8562 41.6706 23 41.4375 23H30.5625C30.3294 23 30.1205 22.8562 30.0372 22.6385C29.9539 22.4208 30.0135 22.1743 30.187 22.0187L35.6245 17.1437ZM32.0326 21.875H39.9674L36 18.318L32.0326 21.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 28.4375C30 28.1268 30.2519 27.875 30.5625 27.875H41.4375C41.7481 27.875 42 28.1268 42 28.4375C42 28.7481 41.7481 29 41.4375 29H30.5625C30.2519 29 30 28.7481 30 28.4375Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingBankAccountGeneric);
export default __webpack_public_path__ + "static/media/billing-bank-account-generic.3af86ec242a35c8690ce276a347faed1.svg";
export { ForwardRef as ReactComponent };